import {kbUserData} from "../utils";
import {convertContentWithImageObjectToArrayOfObjects, generateId, generateMsgId} from "./utils";
import {deepClone, publicChatData} from "../App/utils";
import {chatAddMessages} from "../API/chatAPI";
import {handleCreateChat} from "./handleCreateChat";

export const createSendMessage = ({
                                      isStreaming,
                                      setMessages,
                                      messages,
                                      RequestChatAPI,
                                      navigateToChat,
                                      setKBChats,
                                      itemsAreLoading,
                                      chatId,
                                      inputValue,
                                      setInputValue
}) => {
    return async (props) => {
        let input = props?.injectedMessage || inputValue;
        if (itemsAreLoading || isStreaming || !input) return;

        const newMessage = {
            role: 'user',
            content: input?.includes('"image_url"') ? convertContentWithImageObjectToArrayOfObjects(input) : input,
            userId: publicChatData ? `User_${generateId()}` : kbUserData().chatUsername,
            msgId: generateMsgId()
        };

        setInputValue('');
        if (props?.appendOnly) {
            setMessages((prev)=> [...prev, newMessage]);
        } else if (props?.toChatOnly) {
            setMessages((prev)=> [...prev, deepClone(newMessage)]);
            if (chatId) {
                chatAddMessages(chatId, [deepClone(newMessage)]).then()
            } else {
                handleCreateChat({chatMessages: [deepClone(newMessage)], navigateToChat, setKBChats})
            }
        } else {
            await RequestChatAPI([...messages, newMessage]);
        }
    }
}